export enum ConsentBasis {
  OptInEverywhere = 'OptInEverywhere',
  EuropeanLaw = 'EuropeanLaw',
  ConfirmedOptInEverywhere = 'ConfirmedOptInEverywhere',
}

export enum OverrideConsentBasis {
  SendToSoftOptIns = 'SendToSoftOptIns',
  SendToOptInsOnly = 'SendToOptInsOnly',
  SendToConfirmedOptInsOnly = 'SendToConfirmedOptInsOnly',
  SendToAnyoneWhoHasntExplicitlyOptedOut = 'SendToAnyoneWhoHasntExplicitlyOptedOut',
}

export const basisToOverrideBasisMap = {
  [ConsentBasis.OptInEverywhere]: OverrideConsentBasis.SendToOptInsOnly,
  [ConsentBasis.ConfirmedOptInEverywhere]: OverrideConsentBasis.SendToConfirmedOptInsOnly,
};

export interface CountryOverrideMap {
  [OverrideConsentBasis.SendToOptInsOnly]?: string[];
  [OverrideConsentBasis.SendToConfirmedOptInsOnly]?: string[];
  [OverrideConsentBasis.SendToSoftOptIns]?: string[];
  [OverrideConsentBasis.SendToAnyoneWhoHasntExplicitlyOptedOut]?: string[];
}

export const overrideBasisTranslationMap = {
  [OverrideConsentBasis.SendToOptInsOnly]: 'sendToOptInsOnly',
  [OverrideConsentBasis.SendToConfirmedOptInsOnly]: 'sendToConfirmedOptInsOnly',
  [OverrideConsentBasis.SendToSoftOptIns]: 'sendToSoftOptIns',
  [OverrideConsentBasis.SendToAnyoneWhoHasntExplicitlyOptedOut]: 'sendToAnyoneWhoHasntExplicitlyOptedOut',
};

export const basisTranslationMap = {
  [ConsentBasis.OptInEverywhere]: 'optInEverywhere',
  [ConsentBasis.EuropeanLaw]: 'europeanLaw',
  [ConsentBasis.ConfirmedOptInEverywhere]: 'confirmedOptIn',
};
export interface SiteCountryOverrideMap {
  [countryCode: string]: OverrideConsentBasis;
}
